<template>
  <div class="row">
    <div class="col-12 g c">
        <div class="card card-body">
            <div class="g">
                <button class="btn btn-sm btn-success" @click="current = {}" v-b-modal.add>
                    <i class="fa fa-plus"></i> إضافة تحويل
                </button>
            </div>
            <div class="col-12 table-responsive">
                <table class="table table-hover table-bordered table-striped table-sm">
                    <thead>
                        <th>
                            العنوان
                        </th>
                        <th>
                            المبلغ
                        </th>
                        <th>
                            التفاصيل
                        </th>
                        <th>
                            التاريخ
                        </th>
                        <th>
                            خيارات
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="order in list" :key="order._id">
                            <td>
                                {{ order.title }}
                            </td>
                            <td>
                                {{ order.amount }}
                            </td>
                            <td>
                                <textarea class="form-control" rows="3" readonly v-model="order.details"></textarea>
                            </td>
                            <td>
                                {{ order.date }}
                            </td>
                            <td>
                                <button class="btn btn-sm btn-success" @click="current=order;" v-b-modal.add>
                                    <i class="fa fa-edit"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <!-- basic modal -->
    <b-modal
        id="add"
        hide-footer
    >
        <div class="form-group">
        <label for="">العنوان</label>
        <input type="text"
            class="form-control" v-model="current.title">
        </div>
        <div class="form-group">
        <label for="">التفاصيل</label>
        <textarea type="text"
            class="form-control" v-model="current.details"></textarea>
        </div>
        <div class="form-group">
        <label for="">المبلغ</label>
        <input type="text"
            class="form-control" v-model="current.amount">
        </div>
        <div class="form-group">
        <label for="">التاريخ</label>
        <input type="text"
            class="form-control" v-model="current.date">
        </div>
        <div class="col-12 text-center">
            <button class="btn btn-primary" @click="edit()" v-if="current._id">حفظ</button>
            <button class="btn btn-primary" @click="add()" v-if="!current._id">اضافة</button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { BOverlay, BModal, VBModal } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
    components: {
        BOverlay,
        BModal,
    },
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            list: [],
            current: {}
        }
    },
    created(){
        var g = this;
        g.gett()
    },
    methods: {
        gett(){
            var g = this;
            $.post(api + '/user/apps/manual/list', {
                jwt: g.user.jwt
            }).then(function(r){
                g.list = r.response
            }).fail(function(){
                alert('Error')
            })
        },
        add(){
            var g = this;
            $.post(api + '/user/apps/manual/add', {
                jwt: g.user.jwt,
                title: g.current.title,
                details: g.current.details,
                amount: g.current.amount,
                date: g.current.date,
            }).then(function(r){
                g.gett()
                alert('تم الاضافة', 100)
            }).fail(function(){
                alert('Error')
            })
        },
        edit(){
            var g = this;
            $.post(api + '/user/apps/manual/edit', {
                jwt: g.user.jwt,
                id: g.current._id,
                title: g.current.title,
                details: g.current.details,
                amount: g.current.amount,
                date: g.current.date,
            }).then(function(r){
                g.gett()
                alert('تم التعديل', 100)
            }).fail(function(){
                alert('Error')
            })
        },
    }
}
</script>

<style>

</style>